export const FETCH_DESIGNATION_BASED_REQUEST = "FETCH_DESIGNATION_BASED_REQUEST";
export const FETCH_DESIGNATION_BASED_SUCCESS = "FETCH_DESIGNATION_BASED_SUCCESS";
export const FETCH_DESIGNATION_BASED_FAILURE = "FETCH_DESIGNATION_BASED_FAILURE";
